import React from "react";
import { Alert, AlertTitle, Stack, Typography } from "@mui/material";
import { NameFields, findNameWarnings } from "../generated/dbs-rules";

/**
 * Non-blocking name sanity flags (DBS-263, Cycle 4 Q4.1.2): a title typed into a name field, a word
 * typed twice, or the same value in more than one name field. Shown wherever the names are entered or
 * reviewed; never stops the application.
 */
const NameWarningsAlert: React.FC<{ names: NameFields | undefined, sx?: React.ComponentProps<typeof Alert>['sx'] }> = ({ names, sx }) => {
  const warnings = names === undefined ? [] : findNameWarnings(names)
  if (warnings.length === 0) return null
  return <Alert severity="warning" sx={sx} data-testid="name-warnings">
    <AlertTitle>Please check the names entered</AlertTitle>
    <Stack spacing={1}>
      {warnings.map((warning, index) => <div key={index}>{warning.message}</div>)}
    </Stack>
    <Typography variant="body2" sx={{ marginTop: 1 }}>
      <strong>This is a check, not an error: if the names are right, carry on.</strong>
    </Typography>
  </Alert>
}

export default NameWarningsAlert
